import React from "react";
import { useSelector } from "react-redux";
import { Loader } from "components/Loader";
import { WorkspaceUnavailableScreen } from "components/DesignSystem/WorkspaceUnavailableScreen";
import { canUseCompanyContext, matchesAccessContext, screenHasAccess } from "services/utils/companyAccess";

// moduleName: the screen's provisioning module (routeModuleName). The screen
// opens when that module's has_access is true (the product's when the
// payload has no such module).
export const productAccessDecision = (products, access, companyId, productName, userType, companies, moduleName) => {
  if (!canUseCompanyContext(companyId, userType, companies)) return "select-company";
  if (!Array.isArray(products) || !matchesAccessContext(access, companyId, productName)) return "loading";
  const licensed = products.some((product) => product.product_name === productName);
  return licensed && screenHasAccess(access, moduleName) ? "allowed" : "denied";
};

export const ProductAccessGate = ({ productName, moduleName, children }) => {
  const { productAccess, userScreenAccess, topbarCompanyId, userDetails, companyList } = useSelector((state) => state.tokenReducer);
  if (!productName) return children;
  const decision = productAccessDecision(productAccess, userScreenAccess, topbarCompanyId, productName, userDetails?.type, companyList, moduleName);
  if (decision === "loading") return React.createElement("div", { role: "status", "aria-label": "Loading" },
    React.createElement(Loader, { info: "Loading...", minHeight: "60vh" }));
  if (decision === "select-company") return React.createElement("div", { role: "alert", style: { padding: 24 } }, "Select a company to open this workspace.");
  if (decision === "denied") return <WorkspaceUnavailableScreen />;
  return React.createElement(React.Fragment, { key: String(topbarCompanyId) }, children);
};
